var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.979 2.00446C6.24163 2.47414 2.47414 6.24163 2.00446 10.979C1.94984 11.5299 2.40394 11.98 2.9576 11.98H10.9776C11.5312 11.98 11.98 11.5312 11.98 10.9776V2.9576C11.98 2.40394 11.5299 1.94984 10.979 2.00446Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10083 13.4838C4.80468 17.1943 8.06471 20 11.98 20C16.4093 20 20 16.4093 20 11.98C20 8.06471 17.1943 4.80468 13.4838 4.10083V10.9775C13.4838 12.3617 12.3617 13.4838 10.9775 13.4838H4.10083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartAlt1);
export default __webpack_public_path__ + "static/media/pie-chart-alt-1.071c0bf048ebb507e4ff942d56d8a106.svg";
export { ForwardRef as ReactComponent };